import { enumObjectTypes } from "../constants";

export function SerializeOverrideObj(overrideObj) {
  if (Array.isArray(overrideObj)) {
    return overrideObj.map(SerializeOverrideObj);
  }

  //creates JSON compatible structure to fire off to backend.
  const id = overrideObj.SmartGetFieldValue("RefID");
  const type = overrideObj.SmartGetFieldValue("Type");
  const parentID = overrideObj.SmartGetFieldValue("ParentID");
  const override_id = overrideObj.SmartGetFieldValue("override_id");
  const objType = overrideObj.SmartGetFieldValue("objType") ?? enumObjectTypes.holder;
  const fromOutsidePlan = overrideObj.SmartGetFieldValue("fromOutsidePlan");
  const comment = overrideObj.SmartGetFieldValue("Comment");

  const changes = overrideObj.fChanges;
  const chartRefObj = overrideObj.SmartGetFieldValue("chartRefObj");

  const changeList = changes.map(change => {
    return change.Serialize();
  });

  const serializedObject = {
    id: id,
    parentID: parentID,
    type,
    override_id,
    changes: changeList,
    fromOutsidePlan,
    objType,
    comment: comment,
    chartRefObj
  };

  return serializedObject;
}
